<div class="baloon" [ngStyle]="{backgroundColor: color}">{{content}}</div>
